/**
 * Harden `?next=` against open redirects.
 * Allow only same-origin relative paths starting with a single `/`.
 */
export function safeNext(
  raw: string | null | undefined,
  fallback = '/account/orders',
): string {
  if (raw == null || raw === '') return fallback;

  let value = String(raw);
  // Peel encoded variants (e.g. %2F%2Fevil, %5C) that decode to unsafe forms.
  for (let i = 0; i < 5; i++) {
    if (/[\0\r\n]/.test(value)) return fallback;
    let decoded: string;
    try {
      decoded = decodeURIComponent(value);
    } catch {
      return fallback;
    }
    if (decoded === value) break;
    value = decoded;
  }

  if (/[\0\r\n]/.test(value)) return fallback;
  // Backslash tricks: /\evil → normalize to //evil
  const normalized = value.replace(/\\/g, '/');
  if (!normalized.startsWith('/')) return fallback;
  if (normalized.startsWith('//')) return fallback;
  // Reject scheme-relative or absolute after a leading slash quirk
  if (/^\/[a-z][a-z0-9+.-]*:/i.test(normalized)) return fallback;

  return normalized;
}
